import { Component, Input, TemplateRef } from '@angular/core';

@Component({
	selector: 'ui-tab-item',
	templateUrl: 'ui-tab-item.component.html',
	styleUrls: ['ui-tab-item.component.scss']
})
export class UITabItemComponent {
	
	@Input() tabName? = 'default';
	@Input() templateRef!: TemplateRef<any>;

}
